import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { UserProvider } from "./UserContext";

import AppContent from "./modules/appcontent/AppContent";
import Register from "./modules/public/register/Register";
import Home from "./modules/Home/Home";
import Profile from "./modules/profile/Profile";
import Notfound from "./modules/notfound/Notfound";
import { Toaster } from "react-hot-toast";
import Loader from "./components/Loader";
import Login from "./modules/public/login/Login";
import PrivacyPolicy from "./modules/public/privacy/PrivacyPolicy";
import ContactUs from "./modules/public/privacy/ContactUs";
import CancellationPolicy from "./modules/public/privacy/CancellationPolicy";
import RefundPolicy from "./modules/public/privacy/RefundPolicy";
import ServicePricing from "./modules/public/privacy/ServicePricing";
import TermsAndCondition from "./modules/public/privacy/TermsAndCondition";
import ShippingPolicy from "./modules/public/privacy/ShippingPolicy";
import Products from "./modules/products/Products";
import Wallet from "./modules/profile/Wallet";
import Rewards from "./modules/profile/Rewards";
import Product from "./modules/products/Product";
import Cart from "./modules/cart/Cart";
import Order from "./modules/orders/Order";
import Orders from "./modules/orders/Orders";
import Checkout from "./modules/checkout/Checkout";
import HybridPins from "./modules/pins/HybridPins";
import ScrollToTop from "./util/ScrollToTp";


function App() {
  return (
      <UserProvider>
        <div className="App">
          <div className="toas">
            <Toaster />
          </div>
          <Loader />
          <BrowserRouter>
          <ScrollToTop />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/" element={<AppContent />}>
                <Route index element={<Home />} />
                <Route path="profile" element={<Profile />} />
                <Route path="wallet" element={<Wallet />} />
                <Route path="reward" element={<Rewards />} />
                <Route path="hybrid-pins" element={<HybridPins />} />
                <Route path="products" element={<Products />} />
                <Route path="product/:id" element={<Product />} />
                <Route path="orders" element={<Orders />} />
                <Route path="order/:id" element={<Order />} />
                <Route path="cart" element={<Cart />} />
                <Route path="checkout/:mode" element={<Checkout />} />
                <Route path="privacy-policy" element={<PrivacyPolicy />} />
                <Route path="contact-us" element={<ContactUs />} />
                <Route
                  path="cancellation-policy"
                  element={<CancellationPolicy />}
                />
                <Route path="refund-policy" element={<RefundPolicy />} />
                <Route
                  path="terms-and-conditions"
                  element={<TermsAndCondition />}
                />
                <Route path="service-pricing" element={<ServicePricing />} />
                <Route path="shipping-policy" element={<ShippingPolicy />} />

                <Route path="*" element={<Notfound />} />
              </Route>
              <Route path="*" element={<Notfound />} />
            </Routes>
          </BrowserRouter>
        </div>
      </UserProvider>
  );
}

export default App;
